export enum orderStatusTxt {
    NOT_PLACED = 'Order not Placed',
    DUE = 'Order Due',
    STARTED = 'Started',
    PLACED = 'Placed',
    CONFIRMED = 'Confirmed but not acknowledged',
    CONFIRMED_ACK = 'Confirmed and acknowledged',
    SHIPPED = 'Shipped',
    DELIVERED = 'Received',
    UNSCHEDULED_OFFLINE = 'Started Unscheduled, OFFLINE',
    MIN_VALUE = 1,
    MAX_VALUE = 7,
}
